function initCustomerDataExport() {
  console.log("[initCustomerDataExport] Starting customer export...");

  if (window.customerData && window.customerData.id) {
    console.log("[initCustomerDataExport] Customer data found in window.customerData:", window.customerData);
    sendCustomerDataToSheet(window.customerData);
  } else {
    console.error("[initCustomerDataExport] window.customerData is undefined. Ensure your Shopify template outputs the customer object using Liquid.");
  }
}

function sendCustomerDataToSheet(customerData) {
  var payload = encodeURIComponent(JSON.stringify({ customer: customerData }));
  var GAS_URL = "https://script.google.com/macros/s/AKfycbx0Jv4Rebg-DNLHrTu70xeMdSYysu6IVPpfXSOFdyHJP7UU70y5Vx-FNkN1cQKl3tgh/exec";
  
  var url = GAS_URL + "?mode=writeCustomer&data=" + payload + "&callback=handleExportResponse";
  console.log("[sendCustomerDataToSheet] Sending customer data via JSONP to:", url);
  
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
}

function handleExportResponse(response) {
  console.log("[handleExportResponse] Response from GAS:", response);
}

document.addEventListener("DOMContentLoaded", function() {
  console.log("[DOMContentLoaded] DOM fully loaded. Initializing customer export.");
  initCustomerDataExport();
});